const KEY = "stichb_material_cart";

export function readMaterialCart() {
  try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
}

function write(lines) {
  localStorage.setItem(KEY, JSON.stringify(lines));
  window.dispatchEvent(new Event("stichb-material-cart"));
  return lines;
}

export function addMaterial(product, quantity = 1) {
  const lines = readMaterialCart();
  const index = lines.findIndex((line) => line.product.id === product.id);
  if (index < 0) lines.push({ product, quantity: Number(quantity) || 1 });
  else lines[index].quantity += Number(quantity) || 1;
  return write(lines);
}

export function updateMaterialQuantity(productId, quantity) {
  return write(readMaterialCart().map((line) => line.product.id === productId ? { ...line, quantity: Number(quantity) } : line).filter((line) => line.quantity > 0));
}

export function clearMaterialCart() { return write([]); }
